// extracted by mini-css-extract-plugin
export default {"container":"NewTodoForm_container__hlhAx","NewTodoForm":"NewTodoForm_NewTodoForm__DGIVG","search-input":"NewTodoForm_search-input__7Ii6k"};